<template>
  <Container>
    <h1>Phone Sales Script:</h1>

    <p class="py-2">
      The CSG requires us to meet performance standards for standard telephone services. The minimum CSG requirements are:
    </p>

    <ul>
      <li>(a) Providing written information at least every two years (or upon request at any time) about the CSG performance standards, our obligations and your right to compensation under the CSG;</li>
      <li>(b) Guaranteed maximum periods to connect new services;</li>
      <li>(c) Guaranteed maximum periods for fault rectification;</li>
      <li>(d) Maximum time frames for customer appointments;</li>
    </ul>

    <p class="py-2">
      {{ brandService.getTitle() }} Talk is a VoIP phone service which is provided over your Internet connection.  It is necessary for
      you to agree to the following Customer Service Guarantee Waiver before we can supply you with the
      VoIP service you have ordered. You are entitled to change your mind and withdraw your consent
      within 5 working days, however we are not obligated to supply a service if you choose to do so.
    </p>

    <p class="py-2">
      We need you to do this because we cannot guarantee the date of provisioning or the restoration
      time of your VoIP service if a fault occurs with the internet or your underlying physical connection
      that supports your Internet service.
    </p>

    <p class="py-2">
      The wavier means that you cannot claim compensation if we fail to meet set standards for
      connection times, fault restoration, and appointment times. The wavier does not stop you from
      contacting us about a fault with your service and we will always do our best to restore or provision
      your service as quickly as possible.
    </p>

    <p class="py-2">
      Written details of this waiver will be sent via email upon completion of the application.
    </p>
  </Container>
</template>

<script setup lang="ts">
import Container from '../components/content/Container.vue';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');
</script>
